import { CirclePacking } from '../../models/circlePackingModel';

export const findNode: (node: CirclePacking, nodeId: string) => any = (node, nodeId) => {
  if (node.children) {
    const matchNode = node.children.find((child) => child.id === nodeId);

    if (matchNode) {
      return matchNode;
    }

    return node.children.reduce((match: CirclePacking, child) => match || findNode(child, nodeId), null);
  }
  return null;
};
